import { render, staticRenderFns } from "./SubmitButton.vue?vue&type=template&id=37fe33a6&scoped=true"
import script from "./SubmitButton.vue?vue&type=script&lang=ts"
export * from "./SubmitButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fe33a6",
  null
  
)

export default component.exports